import { withStyles } from "@material-ui/core/styles";
import ErrorList from "./ErrorList";
import styles from "./styles";

export default withStyles(styles)(ErrorList);
